<div class="min-h-screen bg-white">
  <!-- Header -->
  <app-header-nav></app-header-nav>

  <!-- Main Content -->
  <main>
    <!-- Hero Section -->
    <section class="bg-secondary py-20 md:py-32">
      <div class="container mx-auto px-4">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div class="space-y-6">
            <h1 class="text-head md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Welcome to <span class="text-primary">BarHub</span>
            </h1>
            <p class="text-title text-white/90 leading-relaxed">
              Complete bar management platform for modern establishments. Streamline operations, enhance customer
              experience, and grow your business.
            </p>
            <div class="flex flex-col sm:flex-row gap-4 pt-4">
              <button mat-raised-button color="primary" routerLink="/login"
                class="!py-6 !px-8 !text-regular !font-semibold !shadow-lg hover:!shadow-xl transition-all duration-300 transform hover:scale-105">
                <mat-icon class="mr-2">arrow_forward</mat-icon>
                Get Started
              </button>
              <button mat-stroked-button routerLink="/customer"
                class="!py-6 !px-8 !text-regular !font-semibold !border-2 !border-white !text-white hover:!bg-white/10 transition-all duration-300">
                <mat-icon class="mr-2">visibility</mat-icon>
                View Demo
              </button>
            </div>
          </div>
          <div class="flex justify-center lg:justify-end">
            <div class="relative">
              <div class="absolute inset-0 bg-primary/10 rounded-full blur-3xl"></div>
              <mat-icon class="!text-[200px] md:!text-[300px] text-primary/20 relative">local_bar</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Features Section -->
    <section class="py-20 bg-white">
      <div class="container mx-auto px-4">
        <div class="text-center mb-16">
          <h2 class="text-head font-bold text-third mb-4">Our Features</h2>
          <p class="text-title text-pGray mx-auto">Everything you need to manage your bar efficiently and professionally
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <!-- Feature 1: Customer App -->
          <mat-card appearance="outlined"
            class="!shadow-lg hover:!shadow-2xl transition-all duration-300 transform hover:-translate-y-2 !rounded-xl overflow-hidden">
            <div class="bg-blue-50 p-6 flex justify-center">
              <div class="bg-secondary rounded-full p-6">
                <mat-icon class="!text-5xl !w-12 !h-12 text-white">shopping_cart</mat-icon>
              </div>
            </div>
            <mat-card-header class="!pb-4">
              <mat-card-title class="!text-title !font-bold !text-third">Customer App</mat-card-title>
            </mat-card-header>
            <mat-card-content class="!pb-6">
              <p class="text-pGray text-regular mb-6">Enable your customers to order easily via QR code, browse the
                menu, and pay online seamlessly.</p>
              <ul class="space-y-3">
                <li class="flex items-center gap-3 text-third text-small">
                  <mat-icon class="text-secondary !text-xl">check_circle</mat-icon>
                  <span>Simple QR scanning</span>
                </li>
                <li class="flex items-center gap-3 text-third text-small">
                  <mat-icon class="text-secondary !text-xl">check_circle</mat-icon>
                  <span>Intuitive menu</span>
                </li>
                <li class="flex items-center gap-3 text-third text-small">
                  <mat-icon class="text-secondary !text-xl">check_circle</mat-icon>
                  <span>Secure payment</span>
                </li>
              </ul>
            </mat-card-content>
            <mat-card-actions class="!p-6 !pt-0">
              <button mat-button color="primary" routerLink="/customer"
                class="!font-semibold hover:!bg-blue-50 transition-all duration-300">
                <mat-icon>arrow_forward</mat-icon>
                Explore
              </button>
            </mat-card-actions>
          </mat-card>

          <!-- Feature 2: Service Provider -->
          <mat-card appearance="outlined"
            class="!shadow-lg hover:!shadow-2xl transition-all duration-300 transform hover:-translate-y-2 !rounded-xl overflow-hidden">
            <div class="bg-purple-50 p-6 flex justify-center">
              <div class="bg-purple-500 rounded-full p-6">
                <mat-icon class="!text-5xl !w-12 !h-12 text-white">dashboard</mat-icon>
              </div>
            </div>
            <mat-card-header class="!pb-4">
              <mat-card-title class="!text-title !font-bold !text-third">Dashboard</mat-card-title>
            </mat-card-header>
            <mat-card-content class="!pb-6">
              <p class="text-pGray text-regular mb-6">Manage your inventory, orders, staff, and analyze your performance
                with comprehensive tools.</p>
              <ul class="space-y-3">
                <li class="flex items-center gap-3 text-third text-small">
                  <mat-icon class="text-secondary !text-xl">check_circle</mat-icon>
                  <span>Inventory management</span>
                </li>
                <li class="flex items-center gap-3 text-third text-small">
                  <mat-icon class="text-secondary !text-xl">check_circle</mat-icon>
                  <span>Order tracking</span>
                </li>
                <li class="flex items-center gap-3 text-third text-small">
                  <mat-icon class="text-secondary !text-xl">check_circle</mat-icon>
                  <span>Analytics reports</span>
                </li>
              </ul>
            </mat-card-content>
            <mat-card-actions class="!p-6 !pt-0">
              <button mat-button color="primary" routerLink="/service-provider"
                class="!font-semibold hover:!bg-purple-50 transition-all duration-300">
                <mat-icon>arrow_forward</mat-icon>
                Access
              </button>
            </mat-card-actions>
          </mat-card>

          <!-- Feature 3: Payment -->
          <mat-card appearance="outlined"
            class="!shadow-lg hover:!shadow-2xl transition-all duration-300 transform hover:-translate-y-2 !rounded-xl overflow-hidden">
            <div class="bg-emerald-50 p-6 flex justify-center">
              <div class="bg-emerald-500 rounded-full p-6">
                <mat-icon class="!text-5xl !w-12 !h-12 text-white">payment</mat-icon>
              </div>
            </div>
            <mat-card-header class="!pb-4">
              <mat-card-title class="!text-title !font-bold !text-third">Payments</mat-card-title>
            </mat-card-header>
            <mat-card-content class="!pb-6">
              <p class="text-pGray text-regular mb-6">Accept multiple payment methods and track all transactions in
                real-time with secure processing.</p>
              <ul class="space-y-3">
                <li class="flex items-center gap-3 text-third text-small">
                  <mat-icon class="text-secondary !text-xl">check_circle</mat-icon>
                  <span>Multiple methods</span>
                </li>
                <li class="flex items-center gap-3 text-third text-small">
                  <mat-icon class="text-secondary !text-xl">check_circle</mat-icon>
                  <span>Real-time tracking</span>
                </li>
                <li class="flex items-center gap-3 text-third text-small">
                  <mat-icon class="text-secondary !text-xl">check_circle</mat-icon>
                  <span>Secure processing</span>
                </li>
              </ul>
            </mat-card-content>
            <mat-card-actions class="!p-6 !pt-0">
              <button mat-button color="primary" routerLink="/service-provider/payments"
                class="!font-semibold hover:!bg-emerald-50 transition-all duration-300">
                <mat-icon>arrow_forward</mat-icon>
                Manage
              </button>
            </mat-card-actions>
          </mat-card>
        </div>
      </div>
    </section>

    <!-- Stats Section -->
    <section class="py-20 bg-beige/10">
      <div class="container mx-auto px-4">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-8">
          <mat-card
            class="text-center p-8 bg-white rounded-xl hover:shadow-lg transition-all duration-300 transform hover:scale-105">
            <mat-card-content>
              <div class="text-5xl font-bold text-secondary mb-2">9+</div>
              <div class="text-pGray text-regular font-medium">Available Drinks</div>
            </mat-card-content>
          </mat-card>
          <mat-card
            class="text-center p-8 bg-white rounded-xl hover:shadow-lg transition-all duration-300 transform hover:scale-105">
            <mat-card-content>
              <div class="text-5xl font-bold text-secondary mb-2">100%</div>
              <div class="text-pGray text-regular font-medium">Satisfaction Rate</div>
            </mat-card-content>
          </mat-card>
          <mat-card
            class="text-center p-8 bg-white rounded-xl hover:shadow-lg transition-all duration-300 transform hover:scale-105">
            <mat-card-content>
              <div class="text-5xl font-bold text-secondary mb-2">24/7</div>
              <div class="text-pGray text-regular font-medium">Support Available</div>
            </mat-card-content>
          </mat-card>
          <mat-card
            class="text-center p-8 bg-white rounded-xl hover:shadow-lg transition-all duration-300 transform hover:scale-105">
            <mat-card-content>
              <div class="text-5xl font-bold text-secondary mb-2">∞</div>
              <div class="text-pGray text-regular font-medium">Possibilities</div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="py-20 bg-secondary text-white">
      <div class="container mx-auto px-4 text-center">
        <h2 class="text-head font-bold mb-4">Ready to Get Started?</h2>
        <p class="text-title mb-8 text-white/90 mx-auto">Join the establishments that trust BarHub for their management
          needs</p>
        <button mat-raised-button color="accent" routerLink="/register-bar"
          class="!py-6 !px-10 !text-regular !font-semibold !shadow-xl hover:!shadow-2xl transition-all duration-300 transform hover:scale-105">
          <mat-icon class="mr-2">rocket_launch</mat-icon>
          Start Free Trial
        </button>
      </div>
    </section>
  </main>

  <!-- Footer -->
  <app-footer></app-footer>
</div>